<template>
  <div class="login">
    <LogInPage :successRoute="successRoute" />
  </div>
</template>

<script>
import LogInPage from '../components/elements/pages/LogInPage.vue'
export default {
  name: 'LogIn',
  metaInfo: {
    title: 'Login'
  },
  components: {
    LogInPage
  },
  props: {
    successRoute: false
  }
}
</script>
<style scoped lang="less">
@import (reference) "~@/assets/css/variables.less";
section.home-hero {
  background-size: 100% 100%;
  padding: 0;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
  }
}
</style>
